import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComponent, GridModule, GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GVAFitAndProperDeclarationAdminDashboardContent } from './gva-fit-and-proper-declaration-admin-dashboard.model';
import { GVAFitAndProperDeclarationService } from './gva-fit-and-proper-declaration.service';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'ad-gva-fit-and-proper-declaration-admin-dashboard',
  template: `
    @if (content$ | async; as content) {
      <mat-card>
        <ejs-grid
          #grid
          id="grid"
          [dataSource]="content.items"
          [allowGrouping]="true"
          [groupSettings]="groupOptions"
          [allowTextWrap]="true"
        >
          <e-columns>
            <e-column field="sectionName"></e-column>
            <e-column field="questionLabel" headerText="">
              <ng-template #template let-data>
                <div [innerHtml]="data.questionLabel"></div>
              </ng-template>
            </e-column>
            @for (user of content.userColumns; track user) {
              <e-column [field]="user"></e-column>
            }
          </e-columns>
          <ng-template #groupSettingsCaptionTemplate let-data>
            {{ data.key }}
          </ng-template>
        </ejs-grid>
      </mat-card>
    }
  `,
  styles: ['mat-card { padding: 0 }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, GridModule, MatCardModule]
})
export class GvaFitAndProperDeclarationAdminDashboardComponent implements OnInit {
  public content$!: Observable<GVAFitAndProperDeclarationAdminDashboardContent | null>;
  public groupOptions!: GroupSettingsModel;

  @ViewChild('grid')
  public grid!: GridComponent;

  constructor(private service: GVAFitAndProperDeclarationService) {}

  ngOnInit(): void {
    this.content$ = this.service.getManyForAdminDashboard$().pipe(
      tap(() => {
        this.groupOptions = { showDropArea: false, columns: ['sectionName'] };
      })
    );
  }
}
